'use client'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/atoms/collabsible'
import { navigationMenuTriggerStyle } from '@/components/atoms/navigation-menu'
import { TreeunfeLogo } from '@/components/atoms/treeunfe-logo'
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-react'
import Link from 'next/link'
import { useState } from 'react'
import { Drawer } from 'vaul'
import { menuMobile } from './mock'

type NavigationMenuMobileType = {
  children: React.ReactNode
  className: string
}

export function NavigationMenuMobile({
  children,
  className,
}: NavigationMenuMobileType) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false)
  }

  return (
    <div className={cn(className)}>
      <Drawer.Root
        direction="right"
        open={isDrawerOpen}
        onOpenChange={(open) => setIsDrawerOpen(open)}
        aria-label="Menu de navegação"
      >
        <Drawer.Trigger asChild>{children}</Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="fixed inset-0 bg-black/80 z-[100]" />
          <Drawer.Content className="bg-white z-[100] rounded-tl-xl rounded-bl-xl shadow-xl overflow-hidden flex flex-col h-full max-h-screen w-[300px] mt-24 fixed bottom-0 right-0">
            <Drawer.Title className="sr-only">Menu</Drawer.Title>
            <div className="px-4 py-8 space-y-8 overflow-y-auto bg-background-secondary text-gray-950 flex-1 h-auto w-full">
              <div className="flex w-full items-center justify-center">
                <TreeunfeLogo href="/" />
              </div>

              <div className="flex w-full items-center justify-center flex-col">
                <div className="w-full max-w-[212px] space-y-4">
                  {menuMobile?.map((menu) => {
                    if (menu.subMenu) {
                      return (
                        <Collapsible key={menu.id} className="w-full">
                          <CollapsibleTrigger
                            className={cn(
                              `${navigationMenuTriggerStyle()} flex items-center justify-start w-full bg-transparent text-gray-950 hover:bg-white/5 hover:text-gray-900`,
                            )}
                          >
                            <div className="flex w-full items-center justify-between">
                              <div className="flex items-center">
                                <span className="text-gray-950 mr-2">
                                  {menu.icon}
                                </span>
                                <span>{menu.label}</span>
                              </div>
                              <ChevronDown size={16} className="ml-2" />
                            </div>
                          </CollapsibleTrigger>
                          <CollapsibleContent className="w-full flex flex-col space-y-2 py-2">
                            {menu.subMenu?.map((subMenu) => (
                              <Link
                                key={subMenu.id}
                                href={subMenu.href}
                                onClick={handleCloseDrawer}
                                className={cn(
                                  `${navigationMenuTriggerStyle()} pl-4 flex items-center justify-start w-full bg-transparent gap-2 text-gray-950 hover:bg-gray-300 hover:text-gray-900 bg-gray-100 py-6`,
                                )}
                              >
                                <div className="p-2 w-8 h-8 flex items-center justify-center bg-white rounded-md ">
                                  {subMenu.icon}
                                </div>
                                {subMenu.label}
                              </Link>
                            ))}
                          </CollapsibleContent>
                        </Collapsible>
                      )
                    }

                    return (
                      <Link
                        key={menu.id}
                        href={menu.href}
                        onClick={handleCloseDrawer}
                        className={cn(
                          `${navigationMenuTriggerStyle()} flex items-center justify-start w-full bg-transparent text-gray-950 hover:bg-white/5 hover:text-gray-900`,
                        )}
                      >
                        <span className="text-gray-950 mr-2">{menu.icon}</span>
                        {menu.label}
                      </Link>
                    )
                  })}
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  )
}
